<template lang="pug">
v-card-text#loader.text-xs-center(v-if='show')
  v-progress-circular.my-3(indeterminate color='grey lighten-1')
</template>

<script>
export default {
  name: 'Loader',
  props: {
    show: {
      default: true,
    },
  },
  components: {
  },
}
</script>

<style scoped lang="sass">
#loader
  overflow: hidden
</style>
